const CustomerInvoicingStatuses = {
    Preliminary: {
        key: "Preliminary",
        title: "Preliminary",
        value: 0,
        icon: null,
        color: "transparent"
    },
    Submitted: {
        key: "Submitted",
        title: "Submitted",
        value: 1,
        icon: null,
        color: "#990000"
    },
    UploadedToMYOB: {
        key: "UploadedToMYOB",
        title: "Uploaded To MYOB",
        value: 2,
        icon: null,
        color: "#009e0f"
    }
};

const CustomerInvoicingStatusKeys = {
    0: "Preliminary",
    1: "Submitted",
    2: "UploadedToMYOB"
};

export default CustomerInvoicingStatuses;
export {
    CustomerInvoicingStatusKeys
};
